var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupScgLab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 84,
    viewBox: "0 0 490 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 68.3872L9.61104 61.1857C13.0705 67.5317 19.5097 71.1566 26.9573 71.1566C35.656 71.1566 42.2385 66.7758 42.2385 60.5833C42.2385 53.0792 32.0516 48.5471 23.017 44.4683C13.9351 40.2359 3.84431 35.3016 3.84431 22.5606C3.84431 9.2668 14.848 0 28.7837 0C39.8357 0 48.1008 5.59011 51.2732 14.5031L42.2385 21.0493C39.8357 15.5616 34.5021 12.4896 28.8798 12.4896C21.7681 12.4896 16.0974 17.1218 16.0974 22.8632C16.0974 29.2093 23.2574 31.4742 32.6763 35.7037C44.9295 41.3456 54.4444 47.5403 54.4444 60.3296C54.4444 74.7332 42.5273 84 26.813 84C14.0789 84 4.4207 77.754 0 68.3872Z",
    fill: "#186EAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8206 42.1011C62.8206 19.21 82.2056 0 105.375 0C116.064 0.150906 125.936 4.63789 134.017 12.4023L126.498 22.4367C120.719 16.7401 113.2 12.9564 105.119 12.9564C90.1841 12.9564 75.914 25.8638 75.914 42.15C75.914 58.5382 90.3892 71.1922 105.17 71.1922C113.61 71.1922 120.872 67.0595 126.549 61.5115L134.017 71.7976C126.908 78.7055 117.854 84 105.579 84C82.2056 84 62.8206 65.0412 62.8206 42.1011Z",
    fill: "#186EAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.59 44.6216C213.59 68.774 196.368 84 175.634 84C152.425 84 134.017 65.1419 134.017 42.0999C134.017 19.0096 152.524 0 175.188 0C185.234 0.0512717 196.714 4.99142 204.237 12.4532L197.259 23.0414C191.024 16.7903 182.611 12.8581 175.039 12.8581C160.492 12.8581 146.734 25.2607 146.734 42.0999C146.734 58.0344 159.155 71.1419 176.179 71.1419C189.886 71.1419 200.179 62.6203 200.179 50.2183V49.9672H175.485V38.2679H213.244C213.441 40.1353 213.59 42.3539 213.59 44.6216Z",
    fill: "#186EAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.419 71.5258V84H297.35V4.19995H309.342V71.5258H343.419Z",
    fill: "#186EAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.7 30.8784L370.235 84H355.983L393.306 0H394.044L431.368 84H417.063L393.7 30.8784Z",
    fill: "#186EAC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.005 71.7729H447.916V47.3183L463.808 47.268C472.785 47.268 477.885 52.8134 477.885 58.8532C477.885 66.5747 471.117 71.7729 464.005 71.7729ZM447.916 16.3795H463.25C468.841 16.3795 473.746 20.6356 473.746 26.3269C473.746 32.0211 469.234 36.2772 463.103 36.2297L447.916 36.2772V16.3795ZM476.483 40.0161C480.487 39.1723 485.371 32.727 485.371 24.6954C485.371 14.0999 476.15 4.19995 462.514 4.19995H435.556V39.0505V84H465.133C480.829 84 490 71.9211 490 59.6941C490 49.7512 483.592 42.5159 476.483 40.0161Z",
    fill: "#186EAC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.094 33.6H263.846V16.8H247.094V33.6Z",
    fill: "#186EAC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.094 67.2H263.846V50.4H247.094V67.2Z",
    fill: "#186EAC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.342 50.4H247.094V33.6H230.342V50.4Z",
    fill: "#186EAC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.846 50.4H280.598V33.6H263.846V50.4Z",
    fill: "#186EAC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupScgLab);
export default __webpack_public_path__ + "static/media/group_SCG_LAB.db6cf9115a78cf726c3759a78b807d66.svg";
export { ForwardRef as ReactComponent };